// components/index/service-category/aircon-service/AirconRequestSection.jsx
import { useRef, useEffect, useState } from 'react'
import Image from 'next/image'
import { AnimatePresence } from 'framer-motion'
import { openModal } from 'service/modal-service'
import { AirconBooking } from './AirconBooking'
import { AirconItemSelection } from './AirconItemSelection'
import { Services } from '@/index/service/Services'
import { BottomButtons } from './BottomButtons'
import { s3Static } from 'utils/constants'

export default function AirconRequestSectionSlug({
  requestCategorySettings,
  standardServicing,
  chemicalServicing,
  overhaulServicing,
  currencyCd,
  countryName,
  requestType,
  setIsShowJobScope,
  serviceType,
  setServiceType,
  setUnit,
  setUnitType,
  setCost,
  post,
  heroImage,
  title,
  subtitle
}) {
  const [requestForm, setRequestForm] = useState(false)
  const [isShowAirconItemSelection, setIsShowAirconItemSelection] = useState(false)
  const [isQuickBook, setIsQuickBook] = useState(false)
  const [isCustomBook, setIsCustomBook] = useState(false)

  const showJobScope = (serviceType, unitType, unit, cost) => {
      setServiceType(serviceType)
      setUnit(unit)
      setUnitType(unitType)
      setCost(cost)
      openModal(setIsShowJobScope)
  }

  const videoRef = useRef();

  useEffect(() => {  
      videoRef.current.play()
  }, [])

  return (
    <>
      <section id="aircon-servicing-singapore" className='relative'>
          <div className="-mt-14 relative w-full aspect-video sm:h-220 overflow-hidden">
            {/* Mobile Video */}
            <video
              ref={videoRef}
              className="absolute inset-0 w-full h-full object-cover sm:hidden"
              poster={s3Static + "blog/living/aircon/repairman-doing-air-conditioner-service-1920-1080.jpg"}
              title={title}
              muted
              loop
              playsInline
              preload="metadata"
            >
              <source src="/video/stringssg-aircon-service-web.mp4" />
              <source src="/video/stringssg-aircon-service-web.mov" />
            </video>

            {/* Desktop Image */}
            <Image
              src={heroImage}
              fill
              className="hidden sm:block object-cover"
              alt={title}
              quality={100}
              priority
              sizes="100vw"
            />

          </div>  
          <div id="campaign" className= " relative bg-gray-100 sm:bg-transparent sm:text-white w-full py-2 sm:absolute sm:top-1/2 sm:-translate-y-1/2">
                <AirconBooking
                requestCategorySettings={requestCategorySettings}
                setRequestForm={setRequestForm}
                oneTimeServicing={standardServicing}
                chemicalServicing={chemicalServicing}
                overhaulServicing={overhaulServicing}
                setIsQuickBook={setIsQuickBook}
                setIsCustomBook={setIsCustomBook}
                currencyCd={currencyCd}
                countryName={countryName}
                showJobScope={showJobScope}
                serviceType={serviceType}
                setIsShowAirconItemSelection={setIsShowAirconItemSelection}
                title={title}
                subtitle={subtitle}
                />
          </div>
        </section>
        {!requestForm &&
            <BottomButtons countryName={countryName}/>
        }
        {requestForm && 
            <Services
              requestType={requestType}
              requestCategorySettings={requestCategorySettings}
              setRequestForm={setRequestForm}
              isQuickBook={isQuickBook}
              isCustomBook={isCustomBook}
              asSheet
          />
          }
        {isShowAirconItemSelection && (
            <AnimatePresence>
              <AirconItemSelection
                  setIsShowAirconItemSelection={setIsShowAirconItemSelection}
                  setRequestForm={setRequestForm}
                  setIsCustomBook={setIsCustomBook} setIsQuickBook={setIsQuickBook}
                  userId={null}
              />
            </AnimatePresence>
        )}
    </>
  )
}